import { useTheme, type ThemeMode } from '@/contexts/ThemeContext';
import clsx from 'clsx';

const SunIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="3" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M8 1.5V3M8 13V14.5M14.5 8H13M3 8H1.5M12.6 3.4L11.5 4.5M4.5 11.5L3.4 12.6M12.6 12.6L11.5 11.5M4.5 4.5L3.4 3.4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const MoonIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 9.5a5.5 5.5 0 0 1-7-7A5.5 5.5 0 1 0 13.5 9.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MonitorIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.5" y="2.5" width="13" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M5.5 14h5M8 11.5V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const themeOptions: { mode: ThemeMode; label: string; icon: typeof SunIcon }[] = [
  { mode: 'light', label: 'Light', icon: SunIcon },
  { mode: 'dark', label: 'Dark', icon: MoonIcon },
  { mode: 'system', label: 'Auto', icon: MonitorIcon },
];

export function ThemeToggle() {
  const { mode, setMode } = useTheme();

  return (
    <div className="px-2 py-1.5">
      <span className="text-xxs font-medium text-content-tertiary px-1 uppercase tracking-wider">
        Theme
      </span>
      <div className="flex gap-px mt-1 rounded bg-surface-sunken p-0.5">
        {themeOptions.map(({ mode: optionMode, label, icon: IconComponent }) => (
          <button
            key={optionMode}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setMode(optionMode);
            }}
            className={clsx(
              'flex-1 flex items-center justify-center gap-1 rounded px-1 py-1 text-xxs transition-colors',
              mode === optionMode
                ? 'bg-surface text-content-primary font-medium shadow-sm'
                : 'text-content-tertiary hover:text-content-secondary',
            )}
          >
            <IconComponent size={12} />
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
